// Product_BrandList_Component.jsx
import React from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg";
import editIcon from "../../../assests/bosEdit.svg";
import refreshIcon from "../../../assests/bankcard.svg"; // Add refresh icon
import { Button } from "@mui/material";
import LoadingSpinner from "../../Loading/component";
import { useNavigate } from "react-router-dom";
import './productBrandList.css';

const Product_BrandList_Component = ({
  products,
  loading,
  searchTerm,
  setSearchTerm,
  onCreateBrand,
  onRefresh
}) => {
  const navigate = useNavigate();

  return (
    <div className="brand-list-container">
      <Sidebar />
      
      {loading && (
        <div className="full-page-loader">
          <LoadingSpinner />
        </div>
      )}

      <div className="brand-list-content">
        <div className="brand-header">
          <div className="brand-header-top">
            <div className="brand-header-left">
              <Button
                className="back-button"
                onClick={() => navigate(-1)}
                aria-label="Go back"
              >
                <img src={leftArrow} alt="Back" />
              </Button>
              <h1>Brand</h1>
            </div>
            <div className="brand-header-right">
              
              <Button
                className="create-brand-button"
                onClick={onCreateBrand}
                variant="contained"
              >
                + Create Brand
              </Button>
            </div>
          </div>
          
          <div className="brand-search-section">
            
            <div className="search-input-container">
              <input
                type="text"
                placeholder="earch Brand by Name or ID"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="brand-search-input"
              />
            </div>
          </div>
        </div>

      <div className="brand-main-content">
  <div className="brand-cards-container">
    {products.length > 0 ? (
      <div className="brand-cards-grid">
        {products.map((product) => (
          <div key={product.id} className="brand-card-main">
            <div className="brand-card-header">
              <Button className="brand-edit-button">
                <img src={editIcon} alt="Edit" />
              </Button>
            </div>
            
            <div className="brand-card-content">
              <div className="brand-image-container">
                <img 
                  src={product.image_url || 
                    "https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg?cs=srgb&dl=pexels-pixabay-417173.jpg&fm=jpg"
                  } 
                  alt={product.name || 'Brand'} 
                  className="brand-image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg?cs=srgb&dl=pexels-pixabay-417173.jpg&fm=jpg";
                  }}
                />
              </div>
              <div className="brand-details">
                <div className="brand-id-main">
                  <strong>ID {product.id}</strong>
                </div>
                <div className="brand-name-main">
                  <span className="name-label">Name : </span>
                  <span className="name-value">{product.name || 'N/A'}</span>
                </div>
              </div>
            </div>
            
            <div className="brand-divider-main"></div>
            
            <div className="brand-actions-main">
              <Button className="action-btn-primary">View Base</Button>
              <Button className="action-btn-primary">View Variants</Button>
            </div>
          </div>
        ))}
      </div>
    ) : (
      !loading && (
        <div className="no-brands-found">
          <div className="no-data-icon">📭</div>
          <div className="no-data-text">No brands found</div>
          {searchTerm && (
            <div className="no-data-hint">
              Try a different search term
            </div>
          )}
        </div>
      )
    )}
  </div>
</div>
      </div>
    </div>
  );
};

export default Product_BrandList_Component;